<template>
  <div>
    <div class="mb-4">
      <span class="d-block text-xl-h4 text-lg-h4 text-md-h4 text-sm-h5 text-h6 font-weight-black black--text">
        CBT (Computers Based Test)
      </span>
      <small class="pa-1 d-block text-subtitle-2">Halaman kumpulan CBT</small>
    </div>

    <v-row>
      <v-col
        lg="4"
        md="8"
        sm="12"
      >
        <v-text-field
          v-model="search"
          outlined
          :append-icon="icons.mdiMagnify"
          dense
          background-color="white"
          placeholder="Cari"
          @change="searchHandler($event)"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="!isLoadingCard"
      class="match-height"
    >
      <v-col
        v-for="cbtItem, index in cbt"
        :key="index"
        sm="6"
        md="4"
        lg="4"
        xl="4"
      >
        <v-card class="overflow-hidden">
          <div
            class="pa-2 position-absolute"
            style="right: 0;z-index: 1"
          >
            <v-spacer></v-spacer>
            <v-menu
              offset-y
              nudge-bottom="5"
              nudge-left="60"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="20">
                    {{ icons.mdiDotsVertical }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item :to="{name: 'cbt-edit-headmaster', params: {uuid: cbtItem.uuid}}">
                  <v-list-item-title>
                    <div class="d-flex">
                      <div>
                        <v-img
                          width="16"
                          src="@/assets/icons/edit.svg"
                        ></v-img>
                      </div>
                      <small class="ml-2">Edit</small>
                    </div>
                  </v-list-item-title>
                </v-list-item>
                <a @click="confirmDestroy(cbtItem.uuid)">
                  <v-list-item>
                    <v-list-item-title>
                      <div class="d-flex btn-delete">
                        <div>
                          <v-img
                            width="16"
                            src="@/assets/icons/trash-red.svg"
                          ></v-img>
                        </div>

                        <small class="ml-2">Hapus</small>
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </a>
              </v-list>
            </v-menu>
          </div>
          <!-- <v-card
            height="150"
            color="#D14362"
          >

            <div class="d-flex justify-center">
              <div>
                <v-img
                  src="@/assets/images/vector/subject.svg"
                  width="100%"
                ></v-img>
              </div>
            </div>
          </v-card> -->
          <div
            v-if="cbtItem.thumbnail"
            class="position-relative"
          >
            <v-img
              height="150"
              :src="cbtItem.thumbnail"
            ></v-img>
            <v-overlay
              :absolute="true"
              z-index="0"
              opacity="0.25"
              color="#001A33"
            ></v-overlay>
          </div>
          <v-img
            v-else
            height="150"
            src="@/assets/images/vector/cbt.svg"
            width="100%"
          ></v-img>
          <v-card-text
            class="py-4"
          >
            <div class="mb-4">
              <h2 class="font-weight-bold mb-4 black--text">
                {{ cbtItem.name }}
              </h2>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-center mb-2">
                <v-img
                  :src="icons.iconUser"
                  width="20"
                ></v-img>
                <span class="ml-4">Headmaster</span>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-center mb-2">
                <v-img
                  :src="icons.iconCalendar"
                  width="20"
                ></v-img> <span class="ml-4">{{ cbtItem.start_date }}</span>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-center mb-2">
                <v-img
                  :src="icons.iconClock"
                  width="20"
                ></v-img> <span class="ml-4">{{ cbtItem.duration }} Menit</span>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="d-flex align-center mb-2">
                <v-img
                  :src="icons.iconDocument"
                  width="20"
                ></v-img> <span class="ml-4">{{ cbtItem.question.length }} Soal</span>
              </div>
            </div>
            <div class="d-flex align-center">
              <span class="me-4">Token : </span> <h2>{{ cbtItem.token }}</h2>
            </div>
            <!-- <v-divider class="mt-5"></v-divider> -->
            <!-- <div class="d-flex justify-space-between  align-center mt-2">
                <div class="font-weight-bold">
                  20 Orang mengikuti CBT
                </div>
                <div class="d-flex">
                  <v-avatar
                    size="40"
                  >
                    <v-img src="@/assets/images/avatars/1.png"></v-img>
                  </v-avatar>
                  <v-avatar
                    size="40"
                  >
                    <v-img src="@/assets/images/avatars/1.png"></v-img>
                  </v-avatar>
                  <v-avatar
                    size="40"
                  >
                    <v-img src="@/assets/images/avatars/1.png"></v-img>
                  </v-avatar>
                </div>
              </div> -->
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-btn
              color="primary"
              x-large
              width="100%"
              :to="{ name: 'cbt-and-result-headmaster',params: { uuid: cbtItem.uuid }}"
            >
              Lihat Cbt
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-else
      class="my-6"
    >
      <v-col
        v-for="i, index in 3"
        :key="index"
        md="4"
      >
        <v-skeleton-loader
          type="card-avatar,article, actions"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <div class="text-center">
      <div v-if="isEmpty">
        <div
          class="d-flex justify-center"
        >
          <div>
            <v-img
              src="@/assets/images/vector/cbt-empty.svg"
            ></v-img>
            <h3 class="font-weight-bold text--black my-6">
              Belum ada CBT
            </h3>
          </div>
        </div>
      </div>
      <div
        v-if="cbt.length"
        class="my-6"
      >
        <v-pagination
          v-model="page"
          :length="totalPages"
          total-visible="7"
          @change="paginationHandler"
        ></v-pagination>
      </div>
      <v-btn
        color="primary"
        x-large
        :to="{name:'cbt-add-headmaster'}"
      >
        Tambah CBT
      </v-btn>
    </div>
    <ConfirmDialog
      :visible="confirmDialog"
      :is-loading-button="isLoadingButton"
      header="Hapus"
      @close-button="confirmDialog = false"
      @destroy-button="destroy"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import iconCalendar from '@/assets/icons/calendar.svg'
import iconClock from '@/assets/icons/clock.svg'
import iconDocument from '@/assets/icons/document-text.svg'
import iconUser from '@/assets/icons/user.svg'
import ConfirmDialog from '@/views/components/ConfirmDialog.vue'
import { mdiDotsVertical, mdiMagnify } from '@mdi/js'

export default {
  name: 'Cbt',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      icons: {
        iconDocument,
        iconUser,
        iconClock,
        iconCalendar,
        mdiDotsVertical,
        mdiMagnify,
      },
      service: 'cbt',
      school_uuid: '',
      cbt: [],
      uuid: '',
      search: '',
      totalPages: 0,
      totalItems: 0,
      page: 1,
      isLoadingButton: false,
      isDisabledButton: false,
      isLoadingCard: true,
      isEmpty: false,
      confirmDialog: false,
      totalCbt: 0,
    }
  },
  watch: {
    search: {
      handler() {
        this.isLoadingCard = true
        this.getCbt({ cbt: this.search })
      },
    },
    page: {
      handler() {
        this.getCbt()
      },
    },
  },
  mounted() {
    this.getSchoolUuid()

    this.getCbt()
    localStorage.removeItem('cbt')
  },
  methods: {
    async paginationHandler(pageNumber) {
      this.page = pageNumber
    },
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === 'undefined') {
          this.school_uuid = el.uuid
        }
        this.user_uuid = JSON.parse(localStorage.getItem('user')).user.uuid
        this.school_uuid = el.school.uuid
      })

      return true
    },
    async getCbt(params = {}) {
      this.isLoadingCard = true

      await this.$services.ApiServices.list(this.service, {
        ...params,
        per_page: '3',
        page: this.page,
        type_uuid: this.school_uuid,
      }).then(({ data }) => {
        this.cbt = data.data
        this.isEmpty = false
        if (this.cbt.length < 1) {
          this.isEmpty = true
        }
        this.isLoadingCard = false
        this.totalPages = data.meta.last_page
      })
      this.isLoadingCard = false
    },
    confirmDestroy(uuid) {
      this.cbt.uuid = uuid
      this.confirmDialog = true
    },
    async destroy() {
      this.isLoadingButton = true
      this.isDisabledButton = true
      await this.$services.ApiServices.destroy(this.service, this.cbt.uuid).then(
        ({ data }) => {
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
        },
        err => console.error(err),
      )
      this.isLoadingButton = false
      this.isDisabledButton = false
      this.confirmDialog = false
      this.getCbt()
    },
    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },
  },
}
</script>
<style>
.btn-delete {
  color: #e30000 !important;
}
</style>
